import * as types from './mutation-types'
import store from "@/store";

export const loadFilters = ({ commit, state }, { key }) => {
    const user = store.getters["user/currentUser"]?.id
    if(user) {
        const saved = localStorage.getItem(`filters_${user}_${key}`)
        if (saved) {
            commit(types.SET_FILTERS, { key, filters: JSON.parse(saved) })
        }
    }
}
export const saveFilters = ({ commit, state }, { key, filters }) => {
    return new Promise((resolve, reject) => {
        const user = store.getters["user/currentUser"]?.id
        if(user) {
            console.log(user)
            commit(types.SET_FILTERS, { key, filters })
            localStorage.setItem(`filters_${user}_${key}`, JSON.stringify(filters))
        }
    })


}
export const clearFilters = ({ commit, state }, { key }) => {
    const user = store.getters["user/currentUser"]?.id
    if(user) {
        commit(types.SET_FILTERS, { key, filters: {} })
        localStorage.removeItem(`filters_${user}_${key}`)
    }
}

